/**
 * KeyMaster brand logo (real mascot logo).
 */
export default function Logo({ className = "", size = "md" }) {
  const h = size === "sm" ? "h-9" : size === "lg" ? "h-16" : "h-12";
  return (
    <img
      src="/assets/keymaster-logo.webp"
      alt="KeyMaster KFZ – Chiptuning & Schlüsseldienst Cloppenburg"
      className={`${h} w-auto object-contain ${className}`}
    />
  );
}
